import React from "react";
import ReactSelect, { components } from "react-select";
import classnames from 'classnames';
import { debounce } from 'lodash';
import './styles.scss';

const Group = (props) => (<components.Group {...props} />);

const MultiValueLabel = ({ children, ...props }) => {
    const list = props.selectProps.customData.lists.length > 1 ?
        props.selectProps.customData.multiListsShortCodes.find(({SYMBOL_CODE_SHORT}) => SYMBOL_CODE_SHORT === props.data.value.split('_')[0]) :
        props.selectProps.customData.multiListsShortCodes.find(({SYMBOL_CODE}) => SYMBOL_CODE === props.selectProps.customData.lists[0]);
    return (
        <components.MultiValueLabel {...props}>
            <div style={{}}>
                <div>{list ? list.NAME : '<справочник не определен>'}:</div>
                <div style={{marginLeft: 0}}>{children}</div>
            </div>
        </components.MultiValueLabel>
    );
};

const SingleValue = ({ children, ...props }) => {
    const list = props.selectProps.customData.lists.length > 1 ?
        props.selectProps.customData.multiListsShortCodes.find(({SYMBOL_CODE_SHORT}) => SYMBOL_CODE_SHORT === props.data.value.split('_')[0]) :
        props.selectProps.customData.multiListsShortCodes.find(({SYMBOL_CODE}) => SYMBOL_CODE === props.selectProps.customData.lists[0]);
    return (
        <components.SingleValue {...props}>
            <div>
                <div>{list ? list.NAME : '<справочник не определен>'}:</div>
                <div style={{marginLeft: 0}}>{children}</div>
            </div>
        </components.SingleValue>
    );
};

class Select extends React.Component {
    state = {
        notEmpty: false,
    };

    onFocus = (e) => {
        this.setState({ notEmpty: true });

        if (this.props.onFocus) {
            this.props.onFocus(e);
        }
    };

    onBlur = (e) => {
        if (e.target.value === "") {
            this.setState({ notEmpty: false });
        }
    };

    onChange = (data) => {
        const { change, field, multiple } = this.props;

        this.onFocus();
        const value = multiple ? (data || [{value: -1}]).map(({value}) => value) : Array.isArray(data) ? data[0].value : data.value;
        change(value, field);
    };

    componentDidMount() {
        this.setState({ notEmpty: !!this.props.value });
    }

    render() {
        const { field, value, options = [], multiple = false, onOpen, fetchList, multiList, data } = this.props;

        const formatOptionLabel = ({ value, label }) => (
            <div className={classnames("select-option-label", { "_grey": value === 'null' })}>
                {label}
            </div>
        );

        const searchHandler = debounce(val => {
            if (!fetchList || val.length <= 2) {
                return;
            }
            fetchList(val);
        }, 500);

        const _value =
        multiList ? (
            multiple ?
                options.map(f => f.options).flat().filter(option => value.includes(option.value)) :
                options.map(f => f.options).flat().find(option => option.value === value)
            ) : 
            multiple
                ? (!value || (value.length === 1 && value[0] === -1)) ? [] : options.filter(option => value.includes(option.value))
                : (options.find((option) => value === option.value) || '');

        return (
            <ReactSelect
                classNamePrefix="itgrix-cc-select"
                name={field}
                value={_value}
                className="form-input__input form-input__input_select"
                id={"column-" + field}
                onFocus={this.onFocus}
                onBlur={this.onBlur}
                onChange={this.onChange}
                options={options}
                placeholder=""
                styles={{
                    groupHeading: (base) => ({
                        ...base,
                        color: '#6d6d6d',
                        backgroundColor: 'hsl(0,0%,90%)',
                        padding: '10px 20px',
                        marginTop: 0,
                        marginBottom: 4
                    }),
                    group: base => ({...base, paddingTop: 0 })
                }}
                components={{
                    ...(multiList ? (
                        multiple ? { MultiValueLabel } : { SingleValue }
                    ) : {}),
                    ...(multiList ? { Group } : {})
                }}
                isMulti={multiple}
                formatOptionLabel={formatOptionLabel}
                onMenuOpen={() => {
                    onOpen && onOpen();
                }}
                onInputChange={searchHandler}
                onMenuScrollToBottom={() => {
                    console.log('scrolled to bottom')
                    fetchList && fetchList();
                }}
                isValidNewOption={true}
                customData={data}
            />
        );
    }
}

export default Select;
